module.exports = __webpack_public_path__ + "static/nikolas.ab1be6bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/graphics/contributors/nikolas.jpg
// module id = ./src/assets/graphics/contributors/nikolas.jpg
// module chunks = 0 1